var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.styleObject)},[(_vm.url)?_c('el-image',{staticClass:"model-icon sub-box text-center",attrs:{"src":_vm.getResouceCover(_vm.url),"fit":"cover"}}):_c('div',{staticClass:"model-icon sub-box flex-j-c flex-a-c"},[_c('i',{staticClass:"el-icon-user"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }